import React from "react";
import { Text } from "react-konva";

import { IStatsFoulProps } from "./types";
import * as Config from "./configuration";
import { validCoordinate } from "./utils";

const TEXT_SIZE = 14;
const COLOR = Config.COLOR_WIN;

export const StatsFoul = ({ from, symbol = "X" }: IStatsFoulProps) => {
  if (!validCoordinate(from)) {
    return null;
  }
  return (
    <Text
      x={from.x}
      y={from.y}
      text={symbol}
      fill={COLOR}
      fontSize={TEXT_SIZE}
    />
  );
};
